/**
 * Created by bootdo.
 */
import Vue from 'vue'

export let bus = new Vue()



// WEBPACK FOOTER //
// ./src/bus.js